module.exports = __webpack_public_path__ + "img/sun-life-ignition-studio.afe49a07.png";